module.exports = __webpack_public_path__ + "img/ico-chest-gold-disabled.de2ccbc5.png";